import React from 'react';
import { Datagrid as DatagridRA, DatagridProps } from 'react-admin';
import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles({
  header: {
    fontWeight: 'bold',
  },
});

export const Datagrid: React.FC<DatagridProps> = ({ classes, ...props }) => {
  const style = useStyles();
  return (
    <DatagridRA {...props} classes={{ ...classes, headerCell: style.header }}>
      {props.children}
    </DatagridRA>
  );
};

export default Datagrid;
